import s from './FreeConsultation.module.scss';
import Image from 'next/image';
import { getImageData } from '@/lib/utils';

const FreeConsultation = ({ className, data }) => {
  if (!data) return null;
  const { text, placesLeftValue, placesLeftText, icon } = data;
  return (
    <div className={`${s.wrapper} ${className}`}>
      {icon && (
        <div className={s.gift}>
          <Image
            src={getImageData(icon, 'thumbnail').src}
            width={24}
            height={24}
            alt="Emoji"
          />
        </div>
      )}

      <div className={s.content}>
        {text && <p className={`${s.contentText} h6`}>{text}</p>}

        {placesLeftText && placesLeftValue && (
          <div className={s.placesWrapper}>
            <span className={`${s.placesTitle} subtitle`}>
              {placesLeftText}
            </span>
            <span className={`${s.placesNumber} subheading`}>
              {placesLeftValue}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FreeConsultation;
